import { render, staticRenderFns } from "./project-cost-details.vue?vue&type=template&id=7c9d87f3&scoped=true"
import script from "./project-cost-details.vue?vue&type=script&lang=js"
export * from "./project-cost-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9d87f3",
  null
  
)

export default component.exports